// == Import npm
import { NavLink } from 'react-router-dom';

// == Import
import logo from '../../assets/images/logo.png';
import './header.scss';

// == Composant
const Header = () => (
  <header className="header">
      <NavLink className="header-title" to="/"><img src={logo} alt="logo" /></NavLink>
      <nav className="header-reseaux">
        <a className="header-reseaux-link" target="_blank" href="https://www.linkedin.com/in/guillaume-sanchez/"><i className="fab fa-linkedin" /></a>
        <a className="header-reseaux-link" target="_blank" href="https://github.com/Guillaume-Sanchez"><i className="fab fa-github-square" /></a>
      </nav>
  </header>
);

// == Export
export default Header;
